export default "__VITE_ASSET__d04eb461__"